import React, { Component } from 'react'
import logo from './../Images/gfsoft.svg'
import { Link } from 'react-router-dom'
import AutoComplete from './../Function/AutoComplete';

class Home extends Component {

    render(){
        return (
            <div className="home">
                <div className="logo" title="e-Support GFSOFT">
                    <img src={logo} alt="GFSOFT" width="100%"/>
                    <div className="logo-esupport"><span className="esupport"></span></div>
                </div>
                <div className="searchfield">
                    <AutoComplete autoFocus="true" history={this.props.history}/>
                </div>
                <div className="additionalbutton">
                    <Link to="/search/?sort=popular"><button type="button" className="btn btn-red" title="Popular">Popular</button></Link>
                    <Link to="/search/?sort=terbaru"><button type="button" className="btn btn-green" title="Terbaru">Terbaru</button></Link>
                </div>
            </div>
        )
    }
}

export default Home